import React from 'react';

import IndustrySolutions from 'components/pages/IndustrySolutions';
import { agencySolution } from 'components/pages/AudienceSolutions/data';

const Agencies: React.FC = () => <IndustrySolutions solution={agencySolution} />;

export default Agencies;
